// 负责应用根组件组装，与状态 hook、目录、购物车和 checkout 页面关联。
import { categories, useStorefront } from "./useStorefront";
import { AdminView } from "../components/admin/AdminView";
import { CartPanel } from "../components/cart/CartPanel";
import { CatalogView } from "../components/catalog/CatalogView";
import { MockCheckoutView } from "../components/checkout/MockCheckoutView";
import { OrderResultView } from "../components/checkout/OrderResultView";
import { Topbar } from "../components/layout/Topbar";

export const App = () => {
  const storefront = useStorefront();
  const isAdminView =
    window.location.pathname === "/admin" || window.location.hash === "#admin";

  if (isAdminView) {
    return <AdminView />;
  }

  if (storefront.view === "mock-checkout" && storefront.activeOrder) {
    return (
      <MockCheckoutView
        isPaymentResolving={storefront.isPaymentResolving}
        order={storefront.activeOrder}
        paymentError={storefront.paymentError}
        onBackToBag={storefront.backToBag}
        onResolvePayment={storefront.resolveMockPayment}
      />
    );
  }

  if (storefront.view === "order-result" && storefront.activeOrder) {
    return (
      <OrderResultView
        order={storefront.activeOrder}
        onContinueShopping={storefront.continueShopping}
      />
    );
  }

  return (
    <main className="app-shell">
      <Topbar
        itemCount={storefront.itemCount}
        onToggleCart={() =>
          storefront.setIsCartOpen((currentIsOpen) => !currentIsOpen)
        }
      />

      <CatalogView
        categories={categories}
        query={storefront.query}
        selectedCategory={storefront.selectedCategory}
        selectedProduct={storefront.selectedProduct}
        selectedSize={storefront.selectedSize}
        sortMode={storefront.sortMode}
        visibleProducts={storefront.visibleProducts}
        onAddSelectedProduct={storefront.addSelectedProduct}
        onCategoryChange={storefront.setSelectedCategory}
        onQueryChange={storefront.setQuery}
        onSelectProduct={storefront.selectProduct}
        onSelectSize={storefront.setSelectedSize}
        onSortModeChange={storefront.setSortMode}
      />

      <CartPanel
        canCheckout={storefront.canCheckout}
        cartLines={storefront.cartLines}
        checkoutError={storefront.checkoutError}
        checkoutTotal={storefront.checkoutTotal}
        customer={storefront.customer}
        estimatedShipping={storefront.estimatedShipping}
        isCheckoutLoading={storefront.isCheckoutLoading}
        isOpen={storefront.isCartOpen}
        subtotal={storefront.subtotal}
        onCheckout={storefront.startMockCheckout}
        onClose={() => storefront.setIsCartOpen(false)}
        onCustomerChange={storefront.setCustomer}
        onUpdateQuantity={storefront.updateQuantity}
      />
    </main>
  );
};
